// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 107 ? "actions" : chunkId) + "." + {"15":"f0cd4e04","107":"6bfa8acc"}[chunkId] + ".js";
};